(function () {
  const GIFT_PROPERTY = '_mycr7_free_gift';
  let syncInProgress = false;

  function getConfig() {
    const element = document.querySelector('[data-cart-free-gift]');
    if (!element || element.dataset.freeGiftEnabled !== 'true') return null;

    const giftVariantId = Number(element.dataset.freeGiftVariantId);
    const threshold = Number(element.dataset.freeGiftThreshold || 3);
    const keywords = (element.dataset.freeGiftKeywords || '')
      .split(',')
      .map((keyword) => keyword.trim().toLowerCase())
      .filter(Boolean);

    if (!giftVariantId || !threshold || keywords.length === 0) return null;

    return {
      giftVariantId,
      threshold,
      keywords,
    };
  }

  function itemMatchesKeywords(item, keywords) {
    const text = [
      item.product_title,
      item.title,
      item.handle,
      item.url,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return keywords.some((keyword) => text.includes(keyword));
  }

  function isAutoGiftLine(item, giftVariantId) {
    return (
      Number(item.variant_id) === giftVariantId &&
      item.properties &&
      item.properties[GIFT_PROPERTY] === 'true'
    );
  }

  function getCart() {
    return fetch(`${routes.cart_url}.js`, {
      credentials: 'same-origin',
    }).then((response) => response.json());
  }

  function changeLine(key, quantity) {
    return fetch(`${routes.cart_change_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        id: key,
        quantity,
      }),
    }).then((response) => response.json());
  }

  function addGift(giftVariantId) {
    return fetch(`${routes.cart_add_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        items: [
          {
            id: giftVariantId,
            quantity: 1,
            properties: {
              [GIFT_PROPERTY]: 'true',
            },
          },
        ],
      }),
    }).then((response) => response.json());
  }

  function rerenderCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.rerenderContents === 'function') {
      cartDrawer.rerenderContents();
      return;
    }

    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      window.location.reload();
    }
  }

  async function syncFreeGift() {
    const config = getConfig();
    if (!config || syncInProgress) return;

    syncInProgress = true;

    try {
      const cart = await getCart();
      const autoGiftLine = cart.items.find((item) =>
        isAutoGiftLine(item, config.giftVariantId)
      );
      const qualifyingQuantity = cart.items.reduce((total, item) => {
        if (Number(item.variant_id) === config.giftVariantId) return total;
        if (!itemMatchesKeywords(item, config.keywords)) return total;
        return total + item.quantity;
      }, 0);
      const shouldHaveGift = qualifyingQuantity >= config.threshold;
      let changed = false;

      if (shouldHaveGift && !autoGiftLine) {
        await addGift(config.giftVariantId);
        changed = true;
      } else if (!shouldHaveGift && autoGiftLine) {
        await changeLine(autoGiftLine.key, 0);
        changed = true;
      } else if (shouldHaveGift && autoGiftLine.quantity !== 1) {
        await changeLine(autoGiftLine.key, 1);
        changed = true;
      }

      if (changed) rerenderCart();
    } catch (error) {
      console.error(error);
    } finally {
      syncInProgress = false;
    }
  }

  window.MyCR7CartFreeGift = {
    sync: syncFreeGift,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFreeGift);
  } else {
    syncFreeGift();
  }

  document.addEventListener('mycr7:cart-updated', syncFreeGift);
})();
